$(() => {
	$("[data-cover-selector]").each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "cover-selector" */ "./index"
		);
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/cover-selector/index--split.js